module.exports = __webpack_public_path__ + "img/cloth_g1_hat_11.017f8e60.svg";